import { getWebInstrumentations, initializeFaro } from "@grafana/faro-web-sdk";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { faroEnvironmentFromHostname } from "@/lib/faro/environment";

// Browser RUM via Grafana Faro → the Alloy faro.receiver → LGTM stack (replaces
// the dormant Sentry browser SDK; see .aidocs/spike-storefront-faro.md).
//
// Gated on NEXT_PUBLIC_FARO_URL — the shared rum.aypex.io collector, baked at
// build (env-invariant). Absent in dev/build → no-op, exactly like the old DSN
// gate. The `environment` label is derived from the hostname at runtime because
// the single image is Kargo-promoted across stg→prd and can't bake it per-env.
const url = process.env.NEXT_PUBLIC_FARO_URL;

if (url && typeof window !== "undefined") {
  initializeFaro({
    url,
    app: {
      name: "tkf-storefront",
      version: process.env.NEXT_PUBLIC_APP_VERSION || undefined,
      environment: faroEnvironmentFromHostname(window.location.hostname),
    },
    instrumentations: [
      // Errors, unhandled rejections, console, web-vitals, session, view.
      //
      // CSP instrumentation is disabled: Cloudflare Page Shield / Script Monitor
      // injects a *report-only* CSP (`connect-src 'none'`, report-uri
      // .../cdn-cgi/script_monitor/report) that fires a `securitypolicyviolation`
      // for every connection — including our own rum.aypex.io beacon. It blocks
      // nothing (report-only), but Faro's CSP instrumentation would otherwise ship
      // each one to Loki as noise. Our own report-only policy reports straight
      // to /api/csp-report (src/lib/security/csp.ts), so Faro needn't.
      ...getWebInstrumentations({
        enableContentSecurityPolicyInstrumentation: false,
      }),
      // Browser OTEL spans → the SAME Tempo as the backend, so a frontend span
      // links to its backend span within one trace.
      new TracingInstrumentation(),
    ],
  });
}
